module.exports = __webpack_public_path__ + "static/media/multiple-users-silhouette.57ae0cde.png";